export const DISCORD_ROLES = 'DISCORD_ROLES';
export const ROLES_GET_PENDING = 'ROLES_GET_PENDING';
